module.exports = __webpack_public_path__ + "assets/ParrotWithGlasses.f82fab8e.svg";